import { Pipe, PipeTransform } from '@angular/core';

import { AirValidationSector, AirValidationFlightsSector } from '@app/entities/air-validation.response';

@Pipe({
  name: 'airValidationSectorVm',
  standalone: false
})
export class AirValidationSectorVmPipe implements PipeTransform {

  transform(airValidation: AirValidationSector[], ...args: string[]): AirValidationSector[] {
    return airValidation && airValidation.length ? airValidation.map(airValidationSector => {
      const sectorFlights = airValidationSector.Flights;
      return {
        ...airValidationSector,
        Flights: mapAirValidationFlightsSector(sectorFlights)
      };
    }) : [];
  }
}

function mapAirValidationFlightsSector(flights: AirValidationFlightsSector[]): AirValidationFlightsSector[] {
  const maxFlights = flights.length - 1;
  return flights.map((flight: AirValidationFlightsSector, flightIndex: number) => {
    if (flightIndex < maxFlights) {
      const nextFlightIndex = flightIndex + 1;
      const nextFlight = flights[nextFlightIndex];
      return {
        ...flight,
        IsConnectionInDifferentAirport: flight.ArrivalAirport !== nextFlight.DepartureAirport
      };
    } else return flight;
  });
}

